module.exports = __webpack_public_path__ + "assets/img/pjz.2f6b2b15.png";